import { supabase } from '@/core/database/supabase';
import type { ConstructionReworkOrder, ReworkFilters } from '../types/construction-rework.types';

export const ConstructionReworkOrdersService = {
  async getReworkOrders(companyId: string, filters: ReworkFilters = {}): Promise<{ data: ConstructionReworkOrder[], total: number }> {
    let query = supabase
      .from('construction_rework_orders')
      .select(`
        *,
        project:projects(id, name),
        zone:project_zones(id, name),
        team:teams(id, name, code),
        assignee:user_profiles!assigned_to_user_id(id, full_name, avatar_url:avatar_path),
        requester:user_profiles!requested_by(id, full_name)
      `, { count: 'exact' })
      .eq('company_id', companyId);

    if (filters.status && filters.status !== 'all') query = query.eq('status_code', filters.status);
    if (filters.source && filters.source !== 'all') query = query.eq('source_type', filters.source);
    if (filters.projectId) query = query.eq('project_id', filters.projectId);
    if (filters.teamId) query = query.eq('assigned_team_id', filters.teamId);
    if (filters.search) {
      query = query.or(`title.ilike.%${filters.search}%,rework_code.ilike.%${filters.search}%`);
    }

    query = query.order('created_at', { ascending: false });

    const { data, error, count } = await query;
    if (error) throw error;

    return {
      data: (data || []) as ConstructionReworkOrder[],
      total: count || 0
    };
  },

  async getReworkDetail(id: string): Promise<ConstructionReworkOrder> {
    const { data, error } = await supabase
      .from('construction_rework_orders')
      .select(`
        *,
        project:projects(id, name),
        zone:project_zones(id, name),
        team:teams(id, name, code),
        assignee:user_profiles!assigned_to_user_id(id, full_name, avatar_url:avatar_path),
        requester:user_profiles!requested_by(id, full_name)
      `)
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as ConstructionReworkOrder;
  },

  async createRework(data: Partial<ConstructionReworkOrder>): Promise<ConstructionReworkOrder> {
    const { data: result, error } = await supabase
      .from('construction_rework_orders')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ConstructionReworkOrder;
  },

  async updateRework(id: string, updates: Partial<ConstructionReworkOrder>): Promise<void> {
    const { error } = await supabase
      .from('construction_rework_orders')
      .update(updates)
      .eq('id', id);

    if (error) throw error;
  }
};

